/** @file Setup-world lookup for mesh commands over core docSetupWorlds (W2-14), computed once per call. */
import type { Doc, Id } from '@pose2d/format/types';
import { throwError } from '@pose2d/format/throwError';
import { docSetupWorlds } from '@pose2d/core/pose/docSetupWorlds';

/** `worldOf(bone)` = the bone's core setup world [a, b, c, d, tx, ty]; NOT_FOUND for a bone the document lacks. */
export function setupWorldOf(doc: Doc): (bone: Id) => Float64Array {
  const worlds = docSetupWorlds(doc);
  return (bone) => worlds.get(bone) ?? throwError('NOT_FOUND', { kind: 'bone', ref: bone });
}
